import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { CompanyService } from './../../../service/company.service';
import { ApplicationService } from './../../../service/application.service';
import Alert from '../../common/Alert';


const RelatedApplication = () => {
    const companyService = new CompanyService();
    const applicationService = new ApplicationService();

    const [apps, setApps] = useState([]);
    const [companyTypes, setCompanyTypes] = useState([]);
    const [applications, setApplications] = useState([]);
    const [relApplications, setRelApplications] = useState([]);
    const [loading, setLoading] = useState(true);

    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await applicationService.getApplications();
                let dataApp = result.data.map(function (a) {
                    return { value: a.id, label: a.name };
                });
                setApps(dataApp);
                setApplications(result.data);

                const rsCompany = await companyService.getCompanyTypes();
                let dataCom = rsCompany.data.map(function (a) {
                    return { value: a.id, label: a.name };
                });
                setCompanyTypes(dataCom);

                const relAppDataResult = await applicationService.getRelatedApplicationDetails();
                const rldata = relAppDataResult ? relAppDataResult.data : [];
                let appData = [];
                for (let i = 0; i < rldata.length; i++) {
                    appData.push({
                        id: rldata[i].id,
                        applicationId: rldata[i].applicationId,
                        applicationName: rldata[i].applicationName,
                        relatedApplication: rldata[i].relatedApplication ? { value: rldata[i].relatedApplication.id, label: rldata[i].relatedApplication.name } : {},
                        companyTypes: rldata[i].companyTypes ? rldata[i].companyTypes.map((x) => { return { value: x.id, label: x.name } }) : []
                    });
                }
                setRelApplications(appData);

                setLoading(false);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [loading]);

    const handleUpdate = (id, field, value) => {
        const updatedData = relApplications.map(item => {
            if (item.applicationId === id) {
                return { ...item, [field]: value };
            } else {
                return item;
            }
        });
        setRelApplications(updatedData);
    };

    const checkValidation = (sData) => {
        if (!sData.applicationId || sData.applicationId === 0) {
            return false;
        }
        else if (!sData.relatedApplication || sData.relatedApplication.value === 0) {
            return false;
        }
        else if (!sData.companyTypes || sData.companyTypes.length === 0) {
            return false;
        }
        return true;
    };

    const saveRelatedApplication = async (sData) => {
        console.log(sData);
        if (checkValidation(sData) === true) {
            const relApp = {
                id: sData.id,
                applicationId: sData.applicationId,
                relatedApplicationId: sData.relatedApplication.value,
                companyTypes: sData.companyTypes.map((x) => {
                    return {
                        id: x.value,
                        name: x.label,
                        adpath: "",
                        ouassignmentRegex: ""
                    }
                })
            };

            let saveResult = await applicationService.saveRelatedApplication(relApp);
            if (saveResult.status === 200 && saveResult.data.isSuccess === true) {
                setAlertMessage("Application's data has been saved successfully");
                alertOn(true);
                setLoading(true);
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn(true);
            }
        }
        else {
            setAlertMessage("All fields are not selected for this setup");
            alertOn(true);
        }
    };

    const alertOff = () => {
        setIsAlert(false);
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    const renderApplicationTable = () => {
        return (<table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
                <tr style={{ backgroundColor: "lightgray" }}>
                    <th>Application</th>
                    <th>Related Application</th>
                    <th>Company Type</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {relApplications.map(a =>
                    <tr key={a.id}>
                        <td style={{ width: "200px" }}>{a.applicationName}</td>
                        <td style={{ width: "275px" }}><Select options={apps} value={a.relatedApplication} onChange={e => handleUpdate(a.applicationId, "relatedApplication", e)} /></td>
                        <td style={{ width: "375px" }}><Select options={companyTypes} value={a.companyTypes} isMulti onChange={e => handleUpdate(a.applicationId, "companyTypes", e)} /></td>
                        <td style={{ width: "110px" }}>
                            <button onClick={() => saveRelatedApplication(a)} className="btn btn-secondary" style={{ width: "100px", border: "1px solid gray" }}> Configure</button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>);
    }

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderApplicationTable(applications);

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card">
                <h5 className="card-header py-3"><i className="fa fa-folder-open-o" aria-hidden="true"></i> Related Applications</h5>
                <div className="card-body" style={{ height: "75vh" }}>                    
                    <div style={{ height: "100%", overflowY: "auto", paddingRight: "2px", marginTop: "-5px" }}>
                        {contents}
                    </div>
                </div>
            </div>
        </>
    );
}

export default RelatedApplication;